"use client";
import React from "react";
import Breadcrumb from "@/components/Common/Breadcrumb";
import { useTranslations } from "next-intl";
import { useLocale } from "next-intl";
import { formatNumberByLocale } from "@/utils/numberFormatter";

const PrivacyPolicy = () => {
  const t = useTranslations("privacyPolicy");
  const locale = useLocale();

  const sections = [
    {
      title: t("title1"),
      points: [t("p1_1"), t("p1_2"), t("p1_3")],
    },
    {
      title: t("title2"),
      points: [t("p2_1"), t("p2_2"), t("p2_3"), t("p2_4"), t("p2_5")],
    },
    {
      title: t("title3"),
      points: [t("p3_1"), t("p3_2"), t("p3_3")],
    },
    {
      title: t("title4"),
      points: [t("p4_1"), t("p4_2")],
    },
    {
      title: t("title5"),
      points: [t("p5_1"), t("p5_2"), t("p5_3")],
    },
    {
      title: t("title6"),
      points: [t("p6_1"), t("p6_2")],
    },
    {
      title: t("title7"),
      points: [t("p7_1"), t("p7_2")],
    },
    {
      title: t("title8"),
      points: [t("p8_1"), t("p8_2")],
    },
    {
      title: t("title9"),
      points: [t("p9_1"), t("p9_2")],
    },
    {
      title: t("title10"),
      points: [t("p10_1"), t("p10_2"), t("p10_3")],
    },
  ];

  return (
    <section className="section-padding bg-white py-24">
      <Breadcrumb
        pageName={t("pageName")}
        description=""
        bgImages={["/images/breadcrumb/howItWorks.webp"]}
      />

      <div className="container mx-auto px-4 md:px-6 pb-10">
        <p>{t("effectiveDate")}</p>

        <p className="mb-4">{t("intro")}</p>

        <div className="space-y-6">
          {sections.map((section, index) => (
            <div key={index} className="flex items-start gap-3">
              {/* Locale-based Number (English/Hindi/Marathi/Gujarati/Kannada) */}
              <span className="text-lg font-bold ">
                {formatNumberByLocale(locale, index + 1)}.
              </span>

              <div>
                <strong className="block mb-1">{section.title}</strong>

                <ul className="list-disc pl-4">
                  {section.points.map((p, i) => (
                    <li key={i}>{p}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-sm text-gray-500">{t("lastUpdated")}</p>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
